import React from 'react';
import { View } from 'react-native';

import loadingIcon from '@assets/icons/loading.gif';

import { LoadingImage, LoadingText } from './styles';

interface DefaultLoadingProps extends LoadingProps {
  mask?: string;
  isLoading: boolean;
  showSpinner?: boolean;
}

const Loading: React.FC<DefaultLoadingProps> = ({
  isLoading,
  children,
  mask,
  showSpinner = true
}) => {
  if (isLoading && mask) return <LoadingText>{mask}</LoadingText>;
  if (isLoading && showSpinner)
    return <LoadingImage testID="loadingImage" source={loadingIcon} />;
  if (isLoading && !showSpinner) return <View testID="viewLoading" />;
  return children;
};

export default Loading;
